<div class="timesheet-tags-container">
  <div *ngFor="let tag of tags" class="timesheet-tag-wrapper">
    <div *ngIf="tag.type === tagType.ATTESTATION" class="timesheet-tag timesheet-tag--attestation">
      <span class="timesheet-tag__label">Atestado</span>
    </div>
    <div *ngIf="tag.type === tagType.ALLOWANCE" class="timesheet-tag timesheet-tag--allowance">
      <span class="timesheet-tag__label">Abono</span>
    </div>
    <div class="timesheet-tag__date">
      {{ tag.date | date : "dd MMM yyyy" }}
    </div>
  </div>
</div>

